module.exports = __webpack_public_path__ + "img/5.e279f53f.png";